import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "survey-quiz-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_survey_quiz_questions = _resolveComponent("survey-quiz-questions");
  const _component_quiz_readonly_alert = _resolveComponent("quiz-readonly-alert");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["survey-quiz-container", _ctx.isResultMode ? 'quiz-result-container' : ''])
  }, [_ctx.isResultMode ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.$t('view.speach.surveyQuiz.title')), 1)) : _createCommentVNode("", true), _ctx.realtimeUserQuestions.length ? (_openBlock(), _createBlock(_component_survey_quiz_questions, {
    key: 1,
    quiz: _ctx.quiz,
    "user-questions-answers": _ctx.realtimeUserQuestions,
    "is-result-mode": _ctx.isResultMode,
    onAnswerChange: _ctx.emitQuizAnswers
  }, null, 8, ["quiz", "user-questions-answers", "is-result-mode", "onAnswerChange"])) : _createCommentVNode("", true), _ctx.canEdit ? (_openBlock(), _createBlock(_component_quiz_readonly_alert, {
    key: 2,
    "is-speach-template": _ctx.isSpeachTemplate
  }, null, 8, ["is-speach-template"])) : _createCommentVNode("", true)], 2);
}